import { render, staticRenderFns } from "./marketAnalysis.vue?vue&type=template&id=70100b07&scoped=true"
import script from "./marketAnalysis.vue?vue&type=script&lang=js"
export * from "./marketAnalysis.vue?vue&type=script&lang=js"
import style0 from "./marketAnalysis.vue?vue&type=style&index=0&id=70100b07&prod&lang=scss&scoped=true"
import style1 from "./marketAnalysis.vue?vue&type=style&index=1&id=70100b07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70100b07",
  null
  
)

export default component.exports